/**
 * Clayfoot App - Portfolio Website
 * author: Tracy Steven Brown
 * Circa: Dec. 2017
 */

/**
 * JavaScript React Framework
 */
import React from 'react';
import ReactDOM from 'react-dom';
import registerServiceWorker from './registerServiceWorker';

/**
 * JavaScript React-Router
 */
import { BrowserRouter } from 'react-router-dom'

/**
 * Clayfoot application code (React Component)
 */
import App from './App';

/**
 * Clayfoot Web Application
 */
ReactDOM.render((
	<BrowserRouter>
		<App />
	</BrowserRouter>
	), document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js